import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

import { RequestPayload } from './types';
import { Employee, EmployeeCreatePayload, EmployeeUpdatePayload, Level, LevelCreatePayload, LevelUpdatePayload, StructureNode, StructureNodeCreatePayload, StructureNodeUpdatePayload } from './models/structure';

const ENDPOINT = 'org_structure/';

export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getLevels: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Level>>>(
      ENDPOINT + 'level/list/', payload, config
    ),
  createLevel: (payload: LevelCreatePayload) =>
    instance.post<ApiResponse<null>>(ENDPOINT + 'level/create/', payload, config),
  updateLevel: (payload: LevelUpdatePayload) =>
    instance.put<ApiResponse<null>>(ENDPOINT + 'level/update/', payload, config),

  getEmployees: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', Employee>>>(
      ENDPOINT + 'employee/list/', payload, config
    ),
  createEmployee: (payload: EmployeeCreatePayload) =>
    instance.post<ApiResponse<null>>(ENDPOINT + 'employee/create/', payload, config),
  updateEmployee: (payload: EmployeeUpdatePayload) =>
    instance.put<ApiResponse<null>>(ENDPOINT + 'employee/update/', payload, config),

  getNodes: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', StructureNode>>>(
      ENDPOINT + 'node/list/', payload, config
    ),
  createNode: (payload: StructureNodeCreatePayload) =>
    instance.post<ApiResponse<null>>(ENDPOINT + 'node/create/', payload, config),
  updateNode: (payload: StructureNodeUpdatePayload) =>
    instance.put<ApiResponse<null>>(ENDPOINT + 'node/update/', payload, config),
  });